import { getAccessToken } from './apiUtils';
import { call } from './SalesService';
import { DerTraveler } from '../types/der.types';

/**
 * Solicitud del DER (Documento Electronico de Reembolso, sistema DIVA de la
 * AEAT) a traves de la integracion de backend.
 *
 * PENDIENTE: la ruta de la integracion Diva aun no esta facilitada. Mientras
 * DER_ROUTE este vacia no se llama a nada y se avisa al cajero: el cobro y la
 * factura no dependen de esto.
 */
const DER_ROUTE = '';

export const requestDer = async (invoiceId: string, traveler: DerTraveler): Promise<void> => {
    if (!DER_ROUTE) throw new Error('la integración DIVA todavía no está conectada.');

    const accessToken = getAccessToken();
    if (!accessToken) throw new Error('No autorizado');

    await call(DER_ROUTE, {
        access_token: accessToken,
        invoice_id: invoiceId,
        passport: traveler.passport,
        full_name: traveler.fullName,
        birth_date: traveler.birthDate,
        residence_country: traveler.residenceCountry,
        departure_date: traveler.departureDate,
        email: traveler.email,
        phone: traveler.phone,
        transport_number: traveler.transportNumber
    });
};
